import React, { useEffect } from 'react';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';

import routes from 'app/routes';

import { useContext as useUsersContext } from 'components/Users/Context';
import Show from './Views/Show/Index';
import New from './Views/New/Index';

export default function Main() {
  const { dispatch: dispatchUsers, actions: actionsUsers } = useUsersContext();

  useEffect(() => {
    actionsUsers.load(dispatchUsers);
  }, []);

  const router = createBrowserRouter([
    {
      path: routes.members.talentAssessment.show,
      element: <Show />,
    },
    {
      path: routes.members.talentAssessment.new,
      element: <New />,
    },
  ]);

  return (
    <RouterProvider router={router} />
  );
}
